import {RootState} from '@/store'

export const selectUser = (state: RootState) => state.index.user
export const selectNeedLogin = (state: RootState) => state.index.isNeedLogin
export const selectLoad = (state: RootState) => state.index.isLoad
export const selectHexId = (state: RootState) => state.index.hexId
export const selectAddedObject = (state: RootState) => state.index.addedObject
export const selectTypeModalOfMap = (state: RootState) =>
  state.index.typeModalOfMap
export const selectOrbsType = (state: RootState) => state.index.orbsType
export const selectOrbs = (state: RootState) => state.index.orbs
export const selectBillboards = (state: RootState) => state.index.billboards
export const selectTemplatesOrbsR = (state: RootState) =>
  state.index.templatesOrbsR
export const selectClueForModal = (state: RootState) => state.index.clueForModal
export const selectHexaTradingOptions = (state: RootState) =>
  state.index.hexaTradingOptions
export const selectIsFailLoad = (state: RootState) => state.index.isFailLoad
export const selectDefaultOctaCoinOrb = (state: RootState) =>
  state.index.defaultOctaCoinOrb
export const selectDefaultOctaCoinOrbR = (state: RootState) =>
  state.index.defaultOctaCoinOrbR
export const selectLanguage = (state: RootState) => state.index.language
export const selectLastCoordinatesMain = (state: RootState) =>
  state.index.lastCoordinatesMain
export const selectLastCoordinatesAnalytics = (state: RootState) =>
  state.index.lastCoordinatesAnalytics
export const selectAdvisors = (state: RootState) => state.index.advisors
export const selectAdvisor = (state: RootState) => state.index.advisor
export const selectAdvisorIdOnMap = (state: RootState) =>
  state.index.advisorOnMap
export const selectAdvisorDashboard = (state: RootState) =>
  state.index.advisorDashboard
export const selectStoreTab = (state: RootState) => state.index.storeTab
export const selectBoosters = (state: RootState) => state.index.boosters
export const selectInventories = (state: RootState) => state.index.inventories
export const selectMiners = (state: RootState) => state.index.miners
export const selectMisc = (state: RootState) => state.index.misc
export const selectTimers = (state: RootState) => state.index.timers
